import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { priceActions } from '../actions/price.actions';
import {
    selectChainPrice,
    selectChainPriceIsLoaded,
    selectChainPriceLoaded,
    selectChainPriceLoading,
    selectRates,
    selectRatesIsLoaded,
    selectRatesLoaded,
    selectRatesLoading,
    selectStorePrice,
    selectStorePriceIsLoaded,
    selectStorePriceLoaded,
    selectStorePriceLoading,
} from '../selectors/price.selector';

@Injectable({
    providedIn: 'root',
})
export class PriceFacade {
    private readonly store = inject(Store);

    readonly chainPrice = this.store.selectSignal(selectChainPrice);
    readonly chainPriceLoaded = this.store.selectSignal(selectChainPriceLoaded);
    readonly chainPriceLoading = this.store.selectSignal(selectChainPriceLoading);

    readonly storePrice = this.store.selectSignal(selectStorePrice);
    readonly storePriceLoaded = this.store.selectSignal(selectStorePriceLoaded);
    readonly storePriceLoading = this.store.selectSignal(selectStorePriceLoading);

    readonly exchangeRates = this.store.selectSignal(selectRates);
    readonly exchangeRatesLoaded = this.store.selectSignal(selectRatesLoaded);
    readonly exchangeRatesLoading = this.store.selectSignal(selectRatesLoading);

    readonly chainPrice$ = this.store.select(selectChainPrice);
    readonly chainPriceLoaded$ = this.store.select(selectChainPriceLoaded);
    readonly chainPriceLoading$ = this.store.select(selectChainPriceLoading);
    readonly chainPriceIsLoaded$ = this.store.select(selectChainPriceIsLoaded);

    readonly storePrice$ = this.store.select(selectStorePrice);
    readonly storePriceLoaded$ = this.store.select(selectStorePriceLoaded);
    readonly storePriceLoading$ = this.store.select(selectStorePriceLoading);
    readonly storePriceIsLoaded$ = this.store.select(selectStorePriceIsLoaded);

    readonly exchangeRates$ = this.store.select(selectRates);
    readonly exchangeRatesLoaded$ = this.store.select(selectRatesLoaded);
    readonly exchangeRatesLoading$ = this.store.select(selectRatesLoading);
    readonly exchangeRatesIsLoaded$ = this.store.select(selectRatesIsLoaded);

    getChainPrice(chainId: string): void {
        this.store.dispatch(priceActions.getChainPrice({ id: chainId }));
    }

    getStorePrice(storeId: string): void {
        this.store.dispatch(priceActions.getStorePrice({ id: storeId }));
    }

    getExchangeRates(): void {
        this.store.dispatch(priceActions.getExchangeRates());
    }

    clear(): void {
        this.store.dispatch(priceActions.clear());
    }
}
